.quality {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: var(--spacing\/half, 4px);
  background-color: rgba(0, 0, 0, 0.75);
}

/* Option row: icon + label + current value */
.row {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing\/1, 8px);
  padding: var(--spacing\/1, 8px) var(--spacing\/2, 16px);
  cursor: pointer;
  user-select: none;
}

.row:hover {
  background-color: rgba(49, 75, 153, 0.5);
}

/* Back row in submenu mode — label is fully opaque and bold */
.backRow .label {
  opacity: 1;
  font-weight: 600;
}

.icon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color\/text\/text-primary, #fff);
}

.icon svg {
  width: 24px;
  height: 24px;
  fill: currentColor;
}

.label {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 0;
  min-width: 1px;
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-weight: var(--typography\/weight\/regular, 400);
  line-height: 0;
  color: var(--color\/text\/text-primary, #fff);
  opacity: 0.75;
  overflow: hidden;
}

.labelText {
  display: block;
  line-height: 1.7;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
}

.value {
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-weight: var(--typography\/weight\/semibold, 600);
  line-height: 1.7;
  color: var(--color\/text\/text-primary, #fff);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
}

/* Sub-list — always visible when rendered (submenu mode only) */
.list {
  display: flex;
  flex-direction: column;
  gap: var(--spacing\/half, 4px);
  padding: 0;
  margin: 0;
  list-style: none;
  background-color: transparent;
}

.item {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing\/1, 8px);
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-weight: var(--typography\/weight\/regular, 400);
  color: var(--color\/text\/text-primary, #fff);
  line-height: 1.7;
  padding: var(--spacing\/1, 8px) var(--spacing\/2, 16px);
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.itemIcon {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color\/text\/text-primary, #fff);
  opacity: 0.75;
}

.itemLabel {
  display: block;
  flex: 1 0 0;
  min-width: 1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.7;
  font-weight: var(--typography\/weight\/regular, 400);
  opacity: 0.75;
}

.iconSlot {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
}

.item:hover {
  background-color: rgba(49, 75, 153, 0.5);
}

.active {
}

.active .itemLabel {
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-small, 14px);
  font-weight: var(--typography\/weight\/semibold, 600);
  color: var(--color\/text\/text-primary, #fff);
  opacity: 0.75;
}

.active .itemIcon {
  color: var(--color\/text\/text-primary, #fff);
  opacity: 1;
}
